// DS1.15
import React from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../Avatar';
import UserLink from '../Link';
import s from './UserIdentity.scss';
const UserIdentity = ({ size, user, timestamp, className })=>/*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s[size], timestamp && s['with-timestamp'], className),
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: user,
        className: s['avatar'],
        size: size === 'small' ? 24 : 32
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['details']
    }, /*#__PURE__*/ React.createElement(UserLink, {
        user: user,
        className: s['userlink']
    }), timestamp && /*#__PURE__*/ React.createElement("div", {
        className: s['timestamp']
    }, timestamp)));
UserIdentity.displayName = 'UserIdentity';
export default UserIdentity;

//# sourceMappingURL=UserIdentity.js.map